import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var Chip = styled.div.withConfig({
    shouldForwardProp: function (prop) {
        return ![
            "$display",
            "$alignItems",
            "$backgroundColor",
            "$padding",
            "$borderRadius",
            "$fontSize",
            "$color",
            "$isSuccess",
            "$isFailed"
        ].includes(prop);
    },
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  align-items: ", ";\n  background-color: ", ";\n  color: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  font-size: ", ";\n"], ["\n  display: ", ";\n  align-items: ", ";\n  background-color: ", ";\n  color: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  font-size: ", ";\n"])), function (_a) {
    var _b = _a.$display, $display = _b === void 0 ? "flex" : _b;
    return $display;
}, function (_a) {
    var _b = _a.$alignItems, $alignItems = _b === void 0 ? "center" : _b;
    return $alignItems;
}, function (_a) {
    var $isSuccess = _a.$isSuccess, $isFailed = _a.$isFailed;
    return $isSuccess ? "#d4edda" : $isFailed ? "#f8d7da" : "#e2e3e5";
}, function (_a) {
    var $isSuccess = _a.$isSuccess, $isFailed = _a.$isFailed;
    return $isSuccess ? "#155724" : $isFailed ? "#721c24" : "#383d41";
}, function (_a) {
    var _b = _a.$padding, $padding = _b === void 0 ? "6px 10px" : _b;
    return $padding;
}, function (_a) {
    var _b = _a.$borderRadius, $borderRadius = _b === void 0 ? "8px" : _b;
    return $borderRadius;
}, function (_a) {
    var _b = _a.$fontSize, $fontSize = _b === void 0 ? "12px" : _b;
    return $fontSize;
});
var templateObject_1;
